import "./App.css";
import Hero from "./components/Hero/Hero";
import About from "./components/About/About";
import Services from "./components/Service/Services";
import Contact from "./components/Contact/Contact";

function App() {
  return (
    <div>
      <Hero />
      <About />
      <Services />
      <Contact />
    </div>
  );
}

export default App;
